import React, {useEffect, useState, useContext} from "react";
import AuthContext from "context/AuthContext";
import MapBaseManager from "components/maps/MapBaseManager";

const MapAssetContainer = (props) => {
    const {panel} = useContext(AuthContext);
    const ZOOM = 13;
    const initialPos = props.position || props.coords;
    const [position, setPosition] = useState(initialPos);

    useEffect(() => {
        setPosition(props.position || props.coords);
    }, [props.position, props.coords]);

    if (!position || !position.length || !position[0] || !position[1]) return null;

    return <MapBaseManager position={position} center={position} zoom={ZOOM} height="300px" polyline={props.polyline} />;
};

export default MapAssetContainer;
